/* ============================================================
   分割払いシミュレーションバー
   - オプション込み合計をリアルタイム取得し、選択回数で月々を算出
   - 月々 = ceil((合計 + 手数料) / 回数)、手数料 = 合計 × (率/100)
   - カート追加は既存 <product-form> の標準submitボタンを発火
   ============================================================ */
(function () {
  'use strict';

  // 100円あたりの分割払手数料（標準表）
  var FEE_PER_100 = {
    3: 2.04, 5: 3.40, 6: 4.08, 10: 6.80, 12: 8.16,
    15: 10.20, 18: 12.24, 20: 13.60, 24: 16.32
  };

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function yen(n) { return Math.round(n).toLocaleString('ja-JP'); }

  // 月々 = ceil((合計 + 手数料) / 回数), 手数料 = 合計 × (率/100)
  function calcMonthly(total, months) {
    var rate = FEE_PER_100[months];
    if (!rate || total <= 0) return 0;
    var fee = total * (rate / 100);
    return Math.ceil((total + fee) / months);
  }

  // オプション込み現在合計（円）を取得（pc-spec-pdf.js の getCurrentDisplayedTotalPrice 同等）
  function getDisplayedTotal(bar, lastTotal) {
    // 0) 自前カスタマイズ UI (pc-customize.js) が有効なら、その合計 (本体 + 追加料金) を最優先
    if (window.SmolabCustomize && window.SmolabCustomize.isActive) {
      try {
        var st = window.SmolabCustomize.getTotalYen();
        if (st > 0) return st;
      } catch (e) { /* fallthrough */ }
    }
    // 1) 商品ページの価格表示（可視のもの）
    // セール中は販売価格(.price-item--sale)を優先。.price-item--regular を先に見ると
    // 打ち消し線付きの割引前価格(compare_at)を拾い、月々金額が過大になるため。
    var saleEls = document.querySelectorAll('.price__sale .price-item--sale,.price-item--sale');
    for (var si = 0; si < saleEls.length; si++) {
      if (saleEls[si].offsetParent === null) continue; // 非セール時は非表示
      var stx = (saleEls[si].textContent || '').replace(/\s+/g, '');
      var spm = stx.match(/[¥￥]([\d,]+)/) || stx.match(/([\d,]+)/);
      if (spm) { var sn = parseInt(spm[1].replace(/,/g, ''), 10); if (sn > 0) return sn; }
    }
    var priceSel = '.product__price .price-item--regular,.price__regular .price-item--regular,[id^="price-template"] .price-item--regular,.price-item--regular';
    var els = document.querySelectorAll(priceSel);
    for (var i = 0; i < els.length; i++) {
      if (els[i].offsetParent === null) continue; // 非表示はスキップ
      var t = (els[i].textContent || '').replace(/\s+/g, '');
      var pm = t.match(/[¥￥]([\d,]+)/) || t.match(/([\d,]+)/);
      if (pm) { var nn = parseInt(pm[1].replace(/,/g, ''), 10); if (nn > 0) return nn; }
    }
    // 3) フォールバック: data-base-price → 直前値
    var base = parseInt(bar.dataset.basePrice, 10) || 0;
    if (base > 0) return base;
    return lastTotal || 0;
  }

  // 既存カートフォームの送信ボタンを探す（compare-product-page.js のパターン）
  function findSubmitButton(bar) {
    var sid = bar.dataset.sectionId;
    if (!sid) {
      var pf0 = document.querySelector('product-form[data-section-id]');
      if (pf0) sid = pf0.dataset.sectionId;
    }
    var btn = sid && document.getElementById('ProductSubmitButton-' + sid);
    if (btn) return btn;
    var form = document.querySelector('product-form form');
    if (form) {
      return form.querySelector('button[type="submit"][name="add"]') ||
        form.querySelector('button[type="submit"]');
    }
    return null;
  }

  function init(bar) {
    if (bar.dataset.ibBound) return;
    bar.dataset.ibBound = '1';

    var totalEl = bar.querySelector('[data-ib-total]');
    var monthlyEl = bar.querySelector('[data-ib-monthly]');
    var monthsLabel = bar.querySelector('[data-ib-months]');
    var counts = bar.querySelectorAll('[data-ib-count]');
    var addBtn = bar.querySelector('[data-ib-add]');
    var months = parseInt(bar.dataset.defaultMonths, 10) || 24;
    var lastTotal = 0;

    function recalc() {
      var total = getDisplayedTotal(bar, lastTotal);
      if (total > 0) lastTotal = total;
      else total = lastTotal;
      var monthly = calcMonthly(total, months);
      totalEl.textContent = total > 0 ? yen(total) + '円' : '—';
      monthlyEl.textContent = monthly > 0 ? yen(monthly) : '—';
      monthsLabel.textContent = months;
    }
    var debounced = debounce(recalc, 150);

    // 分割回数ピル
    Array.prototype.forEach.call(counts, function (btn) {
      btn.addEventListener('click', function () {
        months = parseInt(btn.dataset.ibCount, 10) || months;
        Array.prototype.forEach.call(counts, function (b) {
          var on = (b === btn);
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        recalc();
      });
    });

    // カート追加: 既存フォームの標準submitボタンをclick（properties付与・AJAX等は既存フローに委譲）
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var sb = findSubmitButton(bar);
        if (!sb) { alert('カートに追加できませんでした。ページを再読み込みしてお試しください。'); return; }
        if (sb.disabled || sb.getAttribute('aria-disabled') === 'true') return; // 売切・必須未選択
        sb.click();
      });
    }

    // ---- リアルタイム追従 ----
    // (a) 自前カスタマイズ UI の選択変更
    document.addEventListener('smolab:customize:change', debounced);

    // (b) MutationObserver: 価格要素のテキスト変化
    var targets = document.querySelectorAll('[id^="price-template"]');
    if (window.MutationObserver && targets.length) {
      var mo = new MutationObserver(debounced);
      Array.prototype.forEach.call(targets, function (t) {
        mo.observe(t, { childList: true, characterData: true, subtree: true });
      });
    }

    // (c) Dawn PUB_SUB（バリアント切替・カート更新・数量変更）
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, debounced);
        if (PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, debounced);
        if (PUB_SUB_EVENTS.quantityUpdate) subscribe(PUB_SUB_EVENTS.quantityUpdate, debounced);
      } catch (e) { /* ignore */ }
    }

    // バー高さを実測してCSS変数に反映（本文padding・LINEボタン位置に連動）
    function setHeight() {
      document.documentElement.style.setProperty('--ib-height', bar.offsetHeight + 'px');
    }
    setHeight();
    window.addEventListener('resize', debounce(setHeight, 200));
    if (window.ResizeObserver) {
      try { new ResizeObserver(setHeight).observe(bar); } catch (e) { /* ignore */ }
    }

    recalc();
    // 非同期初期化後に再計算・再測定（保険）
    setTimeout(function () { setHeight(); recalc(); }, 800);
  }

  function boot() {
    var bar = document.querySelector('[data-installment-bar]');
    if (!bar) return;
    // 親に transform/sticky 等があると position:fixed がビューポート基準でなくなるため、body直下へ移動
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    init(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
